import "../scss/style.scss";

import { accordion } from "./modules/accordion";
import { centerActiveLink } from "./modules/center-active-link";
import { dropdown } from "./modules/dropdown";
import { overlayMenu } from "./modules/overlay-menu";
import { pdfLinks } from "./modules/pdf-links";
import { tabs } from "./modules/tabs";
import { videoAutoplay } from "./modules/video-autoplay";

overlayMenu();

dropdown();

pdfLinks();

videoAutoplay();

accordion();

tabs();

centerActiveLink();
